import './Theme6.css';

import { HomeBanners } from '..';
import { KuposModal } from '../../common';
import React from 'react';
import SearchBox6 from '../common/search-box/SearchBox6';
import ThemeSixOfficeSection from './components/ThemeSixOfficeSection';
import ThemeSixSlides from './components/ThemeSixSlides';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';

function Theme6({ history, operator }) {
  return (
    <div className="montserrat">
      <div
        className="new-container"
        style={{
          marginBottom: 100,
        }}
      >
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vel, asperiores et consequatur
        explicabo autem, quam reprehenderit iure suscipit dolor consectetur, nostrum perferendis
        reiciendis necessitatibus labore ipsa officia praesentium inventore nisi.
        <div className="pullman-san-andreas-section-1">
          <div className="pullman-san-andreas-section-1-left">
            <SearchBox6 history={history} operator={operator} />
          </div>
          <div className="pullman-san-andreas-section-1-right">
            <HomeBanners
              slides={getSlides('Banner', operator)}
              height={'350px'}
              activeDotColor={operator && operator.color_codes && operator.color_codes.button_color}
            />
            <div className="pullman-san-andreas-section-1-right-banner2">
              <img className="" src={getIcons('Banner2')} alt="" />
            </div>
            <div className="pullman-san-andreas-section-1-right-banner3">
              <img src={getIcons('HomeHead2')} alt="" />
            </div>
            <div className="d-flex justify-content-between mt-4 mb-4">
              {getSlides &&
                getSlides.length &&
                getSlides('homeSliders', operator).map(item => (
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{
                      width: '20%',
                    }}
                  >
                    <img src={item.banner} className="px-3" alt="" />
                    <span className="d-inline-block mt-2 black-text font13">{item.text}</span>
                  </div>
                ))}
            </div>

            <div className="pullman-san-andreas-section-1-right-banner4">
              <img src={getIcons('Banner3')} alt="" />
            </div>
            <div className="pullman-san-andreas-section-1-right-banner5">
              <img src={getIcons('HomeHead3')} alt="" />
            </div>
            <ThemeSixOfficeSection />
            <div className="pullman-san-andreas-section-1-right-text1">
              <p
                className="p1 bold-text font-italic font-24px"
                style={{
                  color: operator && operator.theme_color && operator.theme_color,
                }}
              >
                Empresas que confían en nosotros
              </p>
              <p className="p2 font-italic font-18px">
                sé parte de <span className="bold-text">Pullman San Andrés</span>
              </p>
            </div>
            <div className="pullman-san-andreas-section-1-right-companies">
              {/* <ThemeSixSlides slides={getSlides('Comapanies', operator)} /> */}
              <div className="d-flex justify-content-between">
                {getSlides &&
                  getSlides.length &&
                  getSlides('Comapanies', operator).map(item => (
                    <img
                      src={item.banner}
                      style={{
                        width: '18%',
                      }}
                      alt=""
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Theme6;



// WEBPACK FOOTER //
// ./src/features/themes/theme6/Theme6.js